export default __webpack_public_path__ + "img/6d324ffebeb941e083a05e9aa55e96e9.svg";